import type { Form } from '../../../../common/types/form';
import type { Child } from '../../../../common/types/child';
import countryList from '../../../../common/countryList';
import type { DecryptedItem } from '../../../../common/types/items';
import type { Client } from '../../../../common/types/client';

const coreDataForm = (clients: DecryptedItem<Client>[]): Form<Child> => {
  const mothers = clients.map((client) => ({ value: client.id, label: client.payload.name || 'kein Name hinterlegt' }));

  return {
    key: 'coreData',
    fields: [
      {
        key: 'name',
        label: 'Name',
        fieldTypes: 'text',
      },
      {
        key: 'gender',
        label: 'Geschlecht',
        fieldTypes: 'select',
        options: [
          {
            value: 'female',
            label: 'weiblich',
          },
          {
            value: 'male',
            label: 'männlich',
          },
          {
            value: 'diverse',
            label: 'divers',
          },
        ],
      },
      {
        key: 'birthday',
        label: 'Geburtsdatum',
        fieldTypes: 'date',
      },
      {
        key: 'placeOfBirth',
        label: 'Geburtsort',
        fieldTypes: 'text',
      },
      {
        key: 'nationality',
        label: 'Staatsangehörigkeit',
        fieldTypes: 'select',
        options: countryList,
      },
      {
        key: 'religion',
        label: 'Religion',
        fieldTypes: 'select',
        options: [],
      },
      {
        key: 'isEatingPork',
        label: 'Schweinefleisch',
        fieldTypes: 'checkbox',
        breakRowAfterField: true,
      },
      {
        key: 'residenceStatus',
        label: 'Aufenthaltsstatus',
        fieldTypes: 'select',
        options: [],
      },
      {
        key: 'residenceStatusValidUntil',
        label: 'Aufenthaltstatus gültig bis',
        fieldTypes: 'date',
      },
      {
        key: 'custody',
        label: 'Sorgerecht',
        fieldTypes: 'select',
        options: [],
      },
      {
        key: 'rightToDeterminePlaceOfResidence',
        label: 'Aufenthaltsbestimmungsrecht',
        fieldTypes: 'select',
        options: [],
      },
      {
        key: 'isRiskOfChildRemoval',
        label: 'Gefahr des Kindesentzuges',
        fieldTypes: 'checkbox',
        breakRowAfterField: true,
      },
      {
        key: 'clientId',
        label: 'Klient*in',
        fieldTypes: 'select',
        options: mothers,
      },
      {
        key: 'motherLink',
        label: 'Link zur Klient*in',
        fieldTypes: 'link',
        itemFieldKey: 'clientId',
        link: '/clients/${itemFieldKey}',
      },
      {
        key: 'father',
        label: 'Vater des Kindes',
        fieldTypes: 'text',
      },
      {
        key: 'fathersBirthday',
        label: 'Geburtstag des Vaters',
        fieldTypes: 'date',
      },
      {
        key: 'isRegisteredSecondStage',
        label: 'Anmeldung Second Stage',
        fieldTypes: 'checkbox',
      },
      {
        key: 'dateOfAdmission',
        label: 'Auszugsdatum',
        fieldTypes: 'date',
      },
      {
        key: 'notice',
        label: 'Wichtige Infos',
        fieldTypes: 'textArea',
        xsWidth: 12,
      },
    ],
  };
};

export default coreDataForm;
